import React, { useState, useContext, useMemo } from 'react';
import SvgIcon from '../../../Components/Common/Component/SvgIcon';
import { Link } from 'react-router-dom';
import NotificationContext from '../../../_helper/Notification';
import { formatDistanceToNow } from 'date-fns';
import { tr } from 'date-fns/locale';

const timeAgo = (dateString) => {
  if (!dateString) return '';
  try {
    return formatDistanceToNow(new Date(dateString), { addSuffix: true, locale: tr });
  } catch (error) {
    console.error("Error formatting time ago:", dateString, error);
    return '';
  }
};

// Eski renk sınıfları
const borderColors = ['b-l-primary', 'b-l-success', 'b-l-info', 'b-l-warning'];
const fontColors = ['font-primary', 'font-success', 'font-info', 'font-warning']; // Zaman için renkler

const Notificationbar = () => {
  const [notificationDropDown, setNotificationDropDown] = useState(false);
  const { allNotifications, unreadCount, loading /*, MarkNotificationAsRead */ } = useContext(NotificationContext);

  const handleDropdownToggle = () => {
    setNotificationDropDown(!notificationDropDown);
  };

  // Tıklama aksiyonu şimdilik sadece dropdown'ı kapatıyor
  const handleNotificationClick = (id, isRead) => {
    // if (!isRead) {
    //     MarkNotificationAsRead(id); // Opsiyonel: tıklanınca okundu işaretle
    // }
    // İleride bildirim detayına yönlendirme eklenebilir
    setNotificationDropDown(false); // Dropdown'ı kapat
  };

  // Bildirimleri tarihe göre sıralayıp ilk 4'ünü alalım (useMemo ile optimize edilebilir)
  const latestNotifications = useMemo(() => {
    return [...allNotifications] // Orijinal diziyi değiştirmemek için kopyala
      .filter(notification => !notification.isRead) // Sadece okunmamış bildirimleri filtrele
      .sort((a, b) => new Date(b.created) - new Date(a.created)) // Tarihe göre ters sırala (en yeni önce)
      .slice(0, 4); // İlk 4 elemanı al
  }, [allNotifications]);

  return (
    <li className='onhover-dropdown'>
      <div className='notification-box' onClick={handleDropdownToggle}>
        <SvgIcon iconId='notification' />
        {unreadCount > 0 && (
          <span className='badge rounded-pill badge-secondary'>{unreadCount}</span>
        )}
      </div>
      <div className={`notification-dropdown onhover-show-div ${notificationDropDown ? 'active' : ''}`}>
        <h6 className='f-18 mb-0 dropdown-title'>Bildirimler ({unreadCount})</h6>
        {loading ? (
          <div className="p-3 text-center text-muted">Yükleniyor...</div>
        ) : (
          <>
            {latestNotifications.length > 0 ? (
              <ul>
                {/* Sadece ilk 4 bildirim map ediliyor */}
                {latestNotifications.map((notification, index) => (
                  <li
                    key={notification.id}
                    // Eski renk sistemi: index'e göre renk sınıfı atanıyor
                    className={`${borderColors[index % borderColors.length]} border-4`} // Modulo ile renkleri döndür
                    onClick={() => handleNotificationClick(notification.id, notification.isRead)}
                    style={{ cursor: 'pointer' }}
                  >
                    <p> {/* Okundu/Okunmadı class'ı kaldırıldı */}
                      {notification.title || notification.message}
                      {/* Eski renk sistemi: Zaman için index'e göre renk sınıfı */}
                      <span className={`${fontColors[index % fontColors.length]}`}>{' '}{timeAgo(notification.created)}</span>
                    </p>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="p-3 text-center text-muted">Yeni bildirim bulunmamaktadır.</div>
            )}
            <ul>
              <li className="text-center">
                <Link className='f-w-700' to={`${process.env.PUBLIC_URL}/notifications`} onClick={() => setNotificationDropDown(false)}>
                  Tümünü Göster
                </Link>
              </li>
            </ul>
          </>
        )}
      </div>
    </li>
  );
};

export default Notificationbar;
